import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { SMS_GATEWAYS } from "models";
import { Twilio } from "modules/DealerOverviewDashboard/components/Service/components";
import { enumToDropdownOptions } from "utils/common";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

export const Sms = () => {
  const { t } = useTranslation();
  const { watch } = FormHelper.useFormContext();

  const smsGateway = watch("sms_gateway_id");
  const smsGatewayOptions = enumToDropdownOptions({ enumObj: SMS_GATEWAYS, t });

  return (
    <>
      <div className="dealer-overview-subheading">{t("v8_sms_configuration", "SMS configuration")}</div>
      <Form.Group>
        <Form.Field width={8}>
          <FormHelper.Field.Dropdown name="sms_gateway_id" options={smsGatewayOptions} />
        </Form.Field>
      </Form.Group>
      {smsGateway === SMS_GATEWAYS.Twilio && <Twilio />}
    </>
  );
};
